<template>
  <div id="spinner">
    <div class="loading"><i></i><i></i><i></i><i></i><i></i></div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss">
@import "@/styles/components/common/_spinner.scss";
</style>

